/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCashCancel = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M23.707 17.707 21.414 20l2.293 2.293-1.414 1.414L20 21.414l-2.293 2.293-1.414-1.414L18.586 20l-2.293-2.293 1.414-1.414L20 18.586l2.293-2.293z" />
        <path d="M22 15h-2V9.9A5.005 5.005 0 0 1 16.1 6H7.9A5.005 5.005 0 0 1 4 9.9v4.2A5.006 5.006 0 0 1 7.9 18H15v2H2V4h20zM4 18h1.826A3.003 3.003 0 0 0 4 16.174zM4 7.825A3.002 3.002 0 0 0 5.826 6H4zM18.174 6A3.002 3.002 0 0 0 20 7.825V6z" />
        <path d="M12 8a4 4 0 1 1 0 8 4 4 0 0 1 0-8zm0 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4z" />
      </g>
    </g>
  </Icon>
);
export { SvgCashCancel as CashCancel };
